module.exports = __webpack_public_path__ + "img/Honig-aus-2021-800.de5710ae.jpg";